/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './common';
import './survey_response';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "feedbacksurveys": {
        "nested": {
          "FeedbackSurveysExternalService": {
            "methods": {
              "GetSurvey": {
                "requestType": "squareup.feedbacksurveys.GetSurveyRequest",
                "responseType": "squareup.feedbacksurveys.GetSurveyResponse"
              },
              "CreateResponse": {
                "requestType": "squareup.feedbacksurveys.CreateResponseRequest",
                "responseType": "squareup.feedbacksurveys.CreateResponseResponse"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.feedbacksurveys?.nested?.FeedbackSurveysExternalService) {
  $root.addJSON(jsonData);
}

/**
 * Multipass authenticated version of the FeedbackSurveysService. Used primarily for Dashboard
 *
 * SOURCE FeedbackSurveysExternalService @ squareup/feedbacksurveys/service.proto at 16:1
 */
export const FeedbackSurveysExternalService = $root.lookupService('squareup.feedbacksurveys.FeedbackSurveysExternalService');